import React, { Component } from 'react';
import c from './Index.module.scss';
import cx from 'classnames'
import LightMobileCall from '@kugou/light-mobilecall';
import {handleClipboard} from '../../../Utils/Utils/index.js'

class Index extends Component {
  state = {
    dialog: false,
    dCon: ''
  }
  componentDidMount () {
    
  }

  openWx(){
    LightMobileCall.mobileCall(123, {
      url: "weixin://",
      browser: 1
    })
  }

  render () {
    const {show, hideFn} = this.props;
    return (
      <div className='wrap'>
        <div className={cx(c.wxFocus, show && c.show)}>
          <div className={c.inner}>
            <div className={c.close} onClick={() => {
              hideFn()
            }}></div>
            <div className={c.title}>关注微信公众号</div>
              <div className={c.step}>
                <div className={c.left}>
                  <div className={c.info}>
                    <div className={c.p2}>关注“齐音达版权音乐购买”公众号</div>
                  </div>
                </div>
                <div className={c.btn} onClick={(e)=>{
                  handleClipboard("齐音达版权音乐购买", e, ()=>{
                    this.setState({
                      dialog: true,
                      dCon: "已复制公众号名称，请前往微信进行搜索关注"
                    });
                    hideFn()
                  }, ()=>{
                    this.setState({
                      dialog: true,
                      dCon: "请前往微信搜索公众号“齐音达版权音乐购买”进行关注"
                    });
                    hideFn()
                  });
                }}>去关注</div>
              </div>
          </div>
        </div>
        <div className={cx(c.dialog, this.state.dialog && c.show)}>
          <div className={c.box}>
            <div className={c.title}>提示</div>
            <div className={c.content}>{this.state.dCon}</div>
            <div className={c.btns}>
              <div onClick={()=>{
                this.setState({
                  dialog: false
                })
              }}>取消</div>
              <div onClick={()=>{
                this.setState({
                  dialog: false
                })
                this.openWx()
              }}>确定</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Index;
